import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5cd05f8e&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer,QTree,QFooter,QPageContainer,QInput,QIcon,QBar,QBadge,QSeparator,QList,QItem,QItemSection,QBreadcrumbs,QBreadcrumbsEl,QItemLabel} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer,QTree,QFooter,QPageContainer,QInput,QIcon,QBar,QBadge,QSeparator,QList,QItem,QItemSection,QBreadcrumbs,QBreadcrumbsEl,QItemLabel}, component.options.components || {})
